export enum PatientDisplayMode {
	/** Legacy iframe patient-app (postMessage communication) */
	PatientApp = 'patient-app',
	/** Unified-patients component (in-process XState machine) */
	UnifiedPatients = 'unified-patients',
	/** Patient-card MFE (standard launch IteroEventBus communication) */
	PatientCard = 'patient-card'
}
